(function ($) {
    $(document).on('click','[data-wp-toggle=\'password\']',function(e){
        console.log('show password');
        e.stopImmediatePropagation();
        e.preventDefault();

        var element = this;
        var target = $($(element).data('wp-target'));
        var icon = $(element).find('i');
        icon.toggleClass('fa-eye fa-eye-slash');
        if (target.attr('type') === 'password') {
            target.attr('type', 'text');
        } else {
            target.attr('type', 'password');
        }

        var svg_eye = $(element).find('svg.fa-eye');
        var svg_eye_slash = $(element).find('svg.fa-eye-slash');

        svg_eye.toggleClass('d-none');
        svg_eye_slash.toggleClass('d-none');

    });
})(jQuery);


/**
 * WP Filter Visibility
 * Trigger: data-wp-filter="<css-selector>"
 * Targets: data-wp-show-if="<regex>" OR data-wp-hide-if="<regex>"
 */
const WpFilterVisibility = (() => {
    const conditionSelector = '*';

    const getGroupKey = (trigger) => {
        return trigger.dataset.wpFilterGroup || trigger.name || trigger.id || '__default__';
    };

    const getTriggerValues = (trigger, relatedTriggers = []) => {
        const triggerType = (trigger.type || '').toLowerCase();

        if (triggerType === 'checkbox' || triggerType === 'radio') {
            if (!relatedTriggers.length) {
                return trigger.checked ? [trigger.value] : [''];
            }

            const values = relatedTriggers
                .filter((input) => input.checked)
                .map((input) => input.value);

            return values.length ? values : [''];
        }

        return trigger.value ? [trigger.value] : [''];
    };

    const matchesCondition = (pattern, values) => {
        const regex = new RegExp(pattern || '.*');
        return values.some((value) => regex.test(value));
    };

    const getVisibilityTarget = (target) => {
        if (target.tagName && target.tagName.toLowerCase() === 'label') {
            return target;
        }

        return target.closest('.list-group-item') || target.parentElement || target;
    };

    const syncAssociatedLabels = (target, isVisible) => {
        if (!target.id) return;

        const scope = target.closest('form') || document;
        scope.querySelectorAll(`label[for="${target.id}"]`).forEach((label) => {
            label.classList.toggle('d-none', !isVisible);
        });
    };

    const shouldDisableOnHide = (target, visibilityTarget) => {
        return target.dataset.filterVisibility !== 'hide'
            && visibilityTarget.dataset.filterVisibility !== 'hide';
    };

    const syncTargetFields = (container, isVisible) => {
        container.querySelectorAll('input, select, textarea, button').forEach((field) => {
            if (field.dataset.wpFilterDisabledInitial === undefined) {
                field.dataset.wpFilterDisabledInitial = field.disabled ? '1' : '0';
            }

            if (!isVisible) {
                if ((field.type || '').toLowerCase() === 'checkbox' || (field.type || '').toLowerCase() === 'radio') {
                    field.checked = false;
                }

                field.disabled = true;
                return;
            }

            field.disabled = field.dataset.wpFilterDisabledInitial === '1';
        });
    };

    const hasConditionAttributes = (target) => {
        return Array.from(target.attributes || []).some((attribute) => {
            return attribute.name === 'data-wp-show-if'
                || attribute.name === 'data-wp-hide-if'
                || attribute.name.startsWith('data-wp-show-if-')
                || attribute.name.startsWith('data-wp-hide-if-');
        });
    };

    const getConditionValue = (target, prefix, groupKey, allowDefaultFallback = false) => {
        const specificAttribute = `${prefix}-${groupKey}`;
        if (target.hasAttribute(specificAttribute)) {
            return target.getAttribute(specificAttribute);
        }

        if (allowDefaultFallback && target.hasAttribute(prefix)) {
            return target.getAttribute(prefix);
        }

        return null;
    };

    const getTriggerGroups = (trigger) => {
        const targetSelector = trigger.dataset.wpFilter;
        if (!targetSelector) return [];

        const scope = trigger.closest('form') || document;
        const groupedTriggers = new Map();

        Array.from(scope.querySelectorAll('[data-wp-filter]'))
            .filter((candidate) => candidate.dataset.wpFilter === targetSelector)
            .forEach((candidate) => {
                const groupKey = getGroupKey(candidate);

                if (!groupedTriggers.has(groupKey)) {
                    groupedTriggers.set(groupKey, []);
                }

                groupedTriggers.get(groupKey).push(candidate);
            });

        return Array.from(groupedTriggers.entries()).map(([groupKey, triggers]) => ({
            groupKey,
            triggers,
            values: getTriggerValues(triggers[0], triggers),
        }));
    };

    const evaluate = (trigger) => {
        const targetSelector = trigger.dataset.wpFilter;
        if (!targetSelector) return;

        const targets = Array.from(document.querySelectorAll(targetSelector));
        let allTargets = [];

        // Zahrnutí options, pokud je cíl select
        targets.forEach((target) => {
            allTargets.push(target);

            if (target.tagName.toLowerCase() === 'select') {
                target.querySelectorAll('option[data-wp-show-if], option[data-wp-hide-if]').forEach((optionTarget) => {
                    allTargets.push(optionTarget);
                });
                return;
            }

            target.querySelectorAll(conditionSelector).forEach((childTarget) => {
                if (hasConditionAttributes(childTarget)) {
                    allTargets.push(childTarget);
                }
            });
        });

        allTargets = [...new Set(allTargets)];
        const triggerGroups = getTriggerGroups(trigger);
        const selectsToUpdate = new Set(); // Uchováme si selecty pro následnou kontrolu

        allTargets.forEach((target) => {
            let isVisible = true;
            let hasCondition = false;

            triggerGroups.forEach((group) => {
                const allowDefaultFallback = triggerGroups.length === 1;
                const showPattern = getConditionValue(target, 'data-wp-show-if', group.groupKey, allowDefaultFallback);
                const hidePattern = getConditionValue(target, 'data-wp-hide-if', group.groupKey, allowDefaultFallback);

                if (showPattern !== null) {
                    isVisible = isVisible && matchesCondition(showPattern, group.values);
                    hasCondition = true;
                }

                if (hidePattern !== null) {
                    isVisible = isVisible && !matchesCondition(hidePattern, group.values);
                    hasCondition = true;
                }
            });

            if (!hasCondition) return;

            if (target.tagName.toLowerCase() === 'option') {
                target.classList.toggle('d-none', !isVisible);
                target.hidden = !isVisible;
                target.disabled = !isVisible;

                // Pokud měníme option, zaznamenáme si jeho mateřský select
                const parentSelect = target.closest('select');
                if (parentSelect) {
                    selectsToUpdate.add(parentSelect);
                }
            } else {
                const visibilityTarget = getVisibilityTarget(target);
                visibilityTarget.classList.toggle('d-none', !isVisible);
                if (shouldDisableOnHide(target, visibilityTarget)) {
                    syncTargetFields(visibilityTarget, isVisible);
                }
                syncAssociatedLabels(target, isVisible);
            }
        });

        // KONTROLA A RESET SELECTŮ
        // Projdeme všechny selecty, kterým se měnily options
        selectsToUpdate.forEach(select => {
            const selectedOption = select.options[select.selectedIndex];

            // Pokud select nemá vybranou hodnotu, nebo je aktuální volba zablokována (skryta)
            if (!selectedOption || selectedOption.disabled) {
                // Najdeme první option v selectu, který není zablokovaný
                const firstVisibleOption = Array.from(select.options).find(opt => !opt.disabled);

                if (firstVisibleOption) {
                    firstVisibleOption.selected = true;
                    select.value = firstVisibleOption.value;
                } else {
                    // Pokud nezůstal viditelný ani jeden option, select vyprázdníme
                    select.value = '';
                }
            }

            if (select.matches('[data-wp-filter]')) {
                select.dispatchEvent(new Event('change', { bubbles: true }));
            }
        });
    };

    const evaluateAll = (context = document) => {
        context.querySelectorAll('[data-wp-filter]').forEach(evaluate);
    };

    const init = () => {
        document.addEventListener('change', (e) => {
            if (e.target && e.target.matches('[data-wp-filter]')) {
                evaluate(e.target);
            }
        });

        evaluateAll();
    };

    return { init, evaluate, evaluateAll };
})();

window.WpFilterVisibility = WpFilterVisibility;
WpFilterVisibility.init();

/**
 * Prevent leaving page when tracked form contains unsaved changes.
 * Trigger: data-prevent-leave="<form-name>"
 * Reset: window.PreventLeaveReset('<form-name>')
 * Redirect: window.PreventLeaveNavigate('<target-url>')
 */
const PreventLeaveReset = (() => {
    const formStates = new Map();
    const formInitialStates = new Map();
    let allowNextNavigation = false;
    
    const hasDirtyForms = () => Array.from(formStates.values()).some(Boolean);

    const normalizeSearch = (url) => {
        const params = new URLSearchParams(url.search);
        params.delete('persist');

        return Array.from(params.entries())
            .sort(([keyA, valueA], [keyB, valueB]) => {
                if (keyA === keyB) {
                    return valueA.localeCompare(valueB);
                }

                return keyA.localeCompare(keyB);
            })
            .map(([key, value]) => `${key}=${value}`)
            .join('&');
    };

    const shouldAllowNavigation = (targetUrl) => {
        if (!targetUrl) return false;

        const currentUrl = new URL(window.location.href);
        const nextUrl = new URL(targetUrl, window.location.href);
        let canRedirect = nextUrl.origin === currentUrl.origin
            && nextUrl.pathname === currentUrl.pathname
            && nextUrl.searchParams.get('persist') === '1'
            && normalizeSearch(nextUrl) === normalizeSearch(currentUrl);

        return canRedirect;
    };

    const updateBeforeUnload = () => {
        window.onbeforeunload = hasDirtyForms() ? () => true : null;
    };

    const getFieldState = (field) => {
        if (field.type === 'checkbox' || field.type === 'radio') {
            return field.checked;
        }

        return field.value;
    };

    const getFormState = (form) => {
        const state = {};

        form.querySelectorAll('input, textarea, select').forEach((field) => {
            const fieldKey = field.name || field.id;
            if (!fieldKey) return;

            state[fieldKey] = getFieldState(field);
        });

        return JSON.stringify(state);
    };

    const markDirty = (formName) => {
        if (!formName) return;

        formStates.set(formName, true);
        updateBeforeUnload();
    };

    const markClean = (formName) => {
        if (!formName) return;

        formStates.set(formName, false);
        updateBeforeUnload();
    };

    const reset = (formName) => {
        if (!formName) return;

        const form = document.querySelector(`form[data-prevent-leave="${formName}"]`);
        if (form) {
            formInitialStates.set(formName, getFormState(form));
        }

        markClean(formName);
    };

    const navigate = (targetUrl) => {
        if (!targetUrl) return false;

        if (shouldAllowNavigation(targetUrl)) {
            allowNextNavigation = true;
            window.location.href = targetUrl;
            return true;
        }

        if (hasDirtyForms()) {
            return false;
        }

        if(targetUrl === '_self'){
            window.location.reload();
        } else {
            window.location.href = targetUrl;
        }
        return true;
    };

    const init = () => {
        document.querySelectorAll('form[data-prevent-leave]').forEach((form) => {
            const formName = form.dataset.preventLeave;
            if (!formName || form.dataset.preventLeaveInitialized === 'true') return;

            formStates.set(formName, false);
            formInitialStates.set(formName, getFormState(form));
            form.dataset.preventLeaveInitialized = 'true';

            ['input', 'change'].forEach((eventName) => {
                form.addEventListener(eventName, () => {
                    if (getFormState(form) !== formInitialStates.get(formName)) {
                        markDirty(formName);
                        return;
                    }

                    markClean(formName);
                });
            });
        });

        document.addEventListener('click', (event) => {
            const link = event.target.closest('a[href]');
            allowNextNavigation = !!link && shouldAllowNavigation(link.href);
        });

        document.addEventListener('submit', (event) => {
            allowNextNavigation = shouldAllowNavigation(event.target.action || window.location.href);
        });

        window.addEventListener('beforeunload', (event) => {
            if (!hasDirtyForms() || allowNextNavigation) {
                allowNextNavigation = false;
                return;
            }

            event.preventDefault();
            event.returnValue = '';
        });
    };

    init();

    return {
        reset,
        navigate,
    };
})();

window.PreventLeaveReset = PreventLeaveReset.reset;
window.PreventLeaveNavigate = PreventLeaveReset.navigate;
